import { IRootState } from '../../../store'

export const getSctMedicationsOptionsSelector = (state: IRootState) => state.options.sctOptions.sctMedsOptions
